/**
 * Tooltip 常量定义模块。
 * 定义 tooltip 相关的常量，如 CSS 类名等。
 */

/**
 * Tooltip 外层容器的 CSS 类名, 设置在tooltip.className属性上
 */
export const TOOLTIP_WRAP_CLASS_NAME = 'dbl-new-chart-tooltip-wrap';
